import type { BaseApiResponse } from '@vueron/kiska';

export type ApiStatusResponseBody = Partial<BaseApiResponse<any>> & {
  statusCode?: number | string;
};

export const isApiStatusResponseBody = (
  value: unknown,
): value is ApiStatusResponseBody =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getApiStatusCode = (data: unknown) => {
  if (!isApiStatusResponseBody(data)) return null;

  const { statusCode } = data;

  if (typeof statusCode === 'number') return statusCode;
  if (typeof statusCode === 'string' && statusCode.trim()) {
    const parsedStatusCode = Number(statusCode);

    return Number.isNaN(parsedStatusCode) ? null : parsedStatusCode;
  }

  return null;
};

export const isNon2xxStatus = (status: Nullish<number>) =>
  status != null && (status < 200 || status >= 300);
